/**
 * Dictionnaire français — source de vérité.
 *
 * Le dictionnaire anglais est typé sur ces clés : oublier une traduction est une erreur
 * de compilation, pas une chaîne manquante découverte par un client.
 */
export const fr = {
  'app.title': 'Paragon Studio',
  'app.subtitle': 'Licences',

  'nav.servers': 'Mon serveur',
  'nav.licenses': 'Mes licences',
  'nav.admin': 'Back-office',
  'nav.logout': 'Se déconnecter',
  'nav.language': 'English',

  'login.title': 'Connexion',
  'login.intro': 'Connectez-vous avec Discord pour gérer votre serveur et vos licences.',
  'login.button': 'Se connecter avec Discord',
  'login.failed': 'La connexion a échoué.',

  'common.loading': 'Chargement…',
  'common.cancel': 'Annuler',
  'common.confirm': 'Confirmer',
  'common.copy': 'Copier',
  'common.copied': 'Copié',
  'common.save': 'Enregistrer',
  'common.create': 'Créer',
  'common.delete': 'Supprimer',
  'common.close': 'Fermer',
  'common.never': 'jamais',
  'common.none': 'aucun',
  'common.retry': 'Réessayer',
  'common.search': 'Rechercher',
  'common.empty': 'Rien à afficher.',

  'secret.shownOnce': 'Affiché une seule fois',
  'secret.warning':
    'Cette valeur ne sera plus jamais affichée : nous n’en conservons qu’une empreinte. Copiez-la maintenant.',
  'secret.acknowledge': 'J’ai copié',

  'servers.title': 'Mon serveur',
  'servers.none': 'Vous n’avez pas encore de serveur.',
  'servers.create': 'Créer un serveur',
  'servers.nameLabel': 'Nom du réseau',
  'servers.namePlaceholder': 'Mon réseau UHC',
  'servers.quotaReached':
    'Votre quota de serveurs est atteint. Contactez le support si vous exploitez réellement plusieurs réseaux.',
  'servers.role': 'Rôle',
  'servers.members': 'Membres',
  'servers.tokenCreated':
    'Serveur créé. Voici le token d’appairage à coller dans la configuration du plugin.',

  'server.token': 'Token d’appairage',
  'server.tokenHint':
    'Un token pour tout le réseau : tous vos nœuds Spigot utilisent le même, même derrière un proxy.',
  'server.tokenPrefix': 'Préfixe',
  'server.tokenCreated': 'Créé le',
  'server.tokenLastUsed': 'Dernier usage',
  'server.tokenNever': 'jamais utilisé',
  'server.tokenRotate': 'Régénérer',
  'server.tokenRevoke': 'Révoquer',
  'server.tokenGrace': 'Laisser l’ancien token valide pendant',
  'server.tokenGraceMinutes': 'minutes',
  'server.tokenGraceHint':
    'Le temps de mettre à jour vos config.yml sans couper le service. 0 pour une coupure immédiate.',
  'server.tokenRotated': 'Nouveau token. L’ancien reste accepté jusqu’à {until}.',
  'server.tokenRotatedNow': 'Nouveau token. L’ancien est révoqué immédiatement.',
  'server.tokenRevokeConfirm':
    'Révoquer le token coupera l’accès du plugin au prochain renouvellement de bail. Continuer ?',
  'server.tokenGraceActive': 'Token précédent, encore accepté jusqu’à {until}',

  'server.modules': 'Modules actifs sur ce serveur',
  'server.modulesEmpty': 'Aucun module activé. Activez une licence depuis « Mes licences ».',

  'server.team': 'Équipe',
  'server.teamHint':
    'Chaque membre active ses propres licences sur ce serveur. S’il quitte l’équipe, ses modules se désactivent.',
  'server.invite': 'Inviter',
  'server.inviteCreated': 'Code d’invitation créé.',
  'server.inviteRole': 'Rôle',
  'server.inviteUses': 'Utilisations',
  'server.inviteTtl': 'Validité (heures)',
  'server.inviteRevoke': 'Révoquer l’invitation',
  'server.invites': 'Invitations en cours',
  'server.memberRemove': 'Retirer',
  'server.memberLeave': 'Quitter l’équipe',
  'server.memberRemoveConfirm':
    'Retirer ce membre libérera ses licences actives sur ce serveur, avec un délai de 24 h avant qu’il puisse les réactiver ailleurs. Continuer ?',
  'server.memberLeaveConfirm':
    'Quitter l’équipe libérera vos licences actives sur ce serveur, avec un délai de 24 h avant de pouvoir les réactiver ailleurs. Continuer ?',
  'server.transferOwnership': 'Transférer la propriété',
  'server.transferConfirm':
    'Vous deviendrez administrateur et ne pourrez plus supprimer le serveur. Continuer ?',
  'server.delete': 'Supprimer le serveur',
  'server.deleteConfirm':
    'La suppression libère les licences de toute l’équipe, sans délai pour eux, et révoque le token. Continuer ?',
  'server.joinTitle': 'Rejoindre une équipe',
  'server.joinCode': 'Code d’invitation',
  'server.join': 'Rejoindre',

  'server.instances': 'Instances observées',
  'server.instancesHint':
    'Ce que l’API voit réellement de vos serveurs. Plusieurs instances sont normales sur un réseau multi-nœuds.',
  'server.instanceVersion': 'Version',
  'server.instanceIp': 'IP observée',
  'server.instanceDeclared': 'IP déclarée',
  'server.instanceLastSeen': 'Dernier signe de vie',
  'server.instanceNone': 'Aucune instance ne s’est encore signalée.',
  'server.instanceWatched': 'Sous surveillance',

  'licenses.title': 'Mes licences',
  'licenses.none': 'Vous n’avez aucune licence pour le moment.',
  'licenses.allAccess': 'Accès complet',
  'licenses.perpetual': 'Achat définitif',
  'licenses.subscription': 'Abonnement',
  'licenses.activeOn': 'Active sur {server}',
  'licenses.inactive': 'Non activée',
  'licenses.activate': 'Activer',
  'licenses.transfer': 'Transférer',
  'licenses.release': 'Libérer',
  'licenses.releaseConfirm':
    'Libérer cette licence la retire du serveur, et un délai de 24 h s’applique avant de pouvoir la réactiver. Continuer ?',
  'licenses.chooseServer': 'Choisir un serveur',
  'licenses.noServer': 'Créez ou rejoignez d’abord un serveur.',
  'licenses.cooldown': 'Déplaçable dans {duration}',
  'licenses.cooldownHint':
    'Ce délai empêche qu’une licence circule de serveur en serveur. Le support peut le lever.',
  'licenses.expiresOn': 'Échéance le {date}',
  'licenses.transferCount': '{count} transfert(s)',
  'licenses.statusEXPIRED': 'Expirée',
  'licenses.statusGRACE': 'En sursis de paiement',
  'licenses.statusREVOKED': 'Révoquée',
  'licenses.statusREFUNDED': 'Remboursée',
  'licenses.statusPENDING': 'En attente',
  'licenses.statusACTIVE': 'Active',

  'admin.title': 'Back-office',
  'admin.accounts': 'Comptes',
  'admin.signals': 'Surveillance',
  'admin.modules': 'Catalogue',
  'admin.searchPlaceholder': 'Identifiant Discord, pseudo ou email',
  'admin.quota': 'Quota de serveurs',
  'admin.quotaUpdate': 'Modifier le quota',
  'admin.grant': 'Octroyer une licence',
  'admin.grantKind': 'Nature',
  'admin.grantModule': 'Module',
  'admin.grantPeriodEnd': 'Échéance',
  'admin.grantNote': 'Note interne',
  'admin.revoke': 'Révoquer',
  'admin.refund': 'Rembourser',
  'admin.clearCooldown': 'Lever le délai',
  'admin.reason': 'Motif',
  'admin.ownedServers': 'Serveurs possédés',
  'admin.entitlements': 'Licences',
  'admin.signalsEmpty': 'Aucun signal ouvert.',
  'admin.signalResolve': 'Marquer traité',
  'admin.signalOccurrences': '{count} occurrence(s)',
  'admin.moduleKey': 'Clé',
  'admin.moduleKeyHint':
    'Gelée à vie : elle voyage dans les baux signés et le plugin la compare en dur.',
  'admin.moduleName': 'Nom affiché',
  'admin.moduleStatus': 'Statut',
  'admin.moduleAllAccess': 'Inclus dans l’accès complet',
  'admin.moduleCreate': 'Créer un module',
  'admin.expiryJob': 'Passer les abonnements échus',

  'error.title': 'Erreur',
  'error.network': 'L’API est injoignable. Vérifiez votre connexion, puis réessayez.',
  'error.unauthenticated': 'Votre session a expiré. Reconnectez-vous.',
  'error.forbidden': 'Vous n’avez pas les droits nécessaires pour cette action.',
  'error.insufficient_role': 'Votre rôle sur ce serveur ne permet pas cette action.',
  'error.not_found': 'Introuvable.',
  'error.conflict': 'Action impossible dans l’état actuel.',
  'error.invalid_payload': 'Les informations saisies sont invalides.',
  'error.rate_limited': 'Trop de requêtes. Patientez un instant.',
  'error.internal_error': 'Une erreur interne est survenue. Réessayez plus tard.',
  'error.server_quota_reached':
    'Votre quota de serveurs est atteint. Le support peut le relever si vous exploitez plusieurs réseaux.',
  'error.member_limit_reached': 'Cette équipe a atteint son nombre maximal de membres.',
  'error.invite_limit_reached': 'Trop d’invitations en cours. Révoquez-en une d’abord.',
  'error.invalid_invite': 'Ce code d’invitation est invalide, expiré ou déjà utilisé.',
  'error.already_active': 'Cette licence est déjà active sur un serveur.',
  'error.already_on_server': 'Cette licence est déjà sur ce serveur.',
  'error.not_active': 'Cette licence n’est active sur aucun serveur.',
  'error.cooldown_active': 'Cette licence est encore en délai de déplacement.',
  'error.entitlement_not_active': 'Cette licence n’est plus utilisable.',
  'error.owner_must_transfer_first':
    'Le propriétaire ne peut pas être retiré : transférez d’abord la propriété.',
  'error.owner_role_immutable': 'Le rôle du propriétaire ne se modifie pas.',
  'error.quota_below_existing':
    'Le quota ne peut pas être inférieur au nombre de serveurs déjà possédés.',
  'error.module_key_taken': 'Cette clé de module est déjà prise.',
  'error.csrf_failed': 'Requête refusée. Rechargez la page et réessayez.',
  'error.oauth_unconfigured': 'La connexion Discord n’est pas configurée sur ce serveur.',
  'error.access_denied': 'Vous avez refusé l’autorisation Discord.',
  'error.state_mismatch': 'La connexion a expiré. Réessayez.',
  'error.account_suspended': 'Ce compte est suspendu.',

  // Le seul message d'erreur volontairement bavard : c'est celui qui, sinon, génère
  // un ticket à chaque fois (DESIGN.md §4.10).
  'error.private_network.title': 'Adresse réseau non routable',
  'error.private_network.body':
    'L’API voit votre serveur arriver depuis une adresse privée (127.x, 10.x, 192.168.x…). ' +
    'Deux causes possibles : vous testez le plugin en local, ou le reverse proxy devant ' +
    'l’API ne transmet pas l’adresse réelle. Utilisez la commande de diagnostic du plugin ' +
    'pour voir l’adresse observée, et contactez le support si vous testez en local.',
} as const;

export type TranslationKey = keyof typeof fr;
